import * as Yup from "yup";

export const dataModel = {
  observations: "",
};

export const validationDataModel = () => {
  return Yup.object().shape({
    observations: Yup.string().required("forms.validations.required")
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
